import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import Box from '@mui/material/Box';


const Success = () => {
  return (
    <> <Box mb={2}>
        <Typography align="left" variant="h3" component="p" color="secondary">
          Hooray <ThumbUpIcon fontSize="large" />
        </Typography>
        <Typography
          align="left"
          variant="body1"
          component="p"
          color="secondary">
          Du hast <b>3 Punkte</b> verdient
        </Typography>
      </Box>
    </>
  );
};
export default Success;
